<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="d-flex">
          <div class="form-base__title">
            Реквизиты документа, подтверждающего полномочия представителя
          </div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="ml-1" v-bind="attrs" v-on="on"
                >{{ mdiAlertCircleOutline }}
              </v-icon>
            </template>
            <span>
              Например, доверенность или иной документ, подтверждающий
              полномочия
            </span>
          </v-tooltip>
        </div>
      </v-col>

      <v-col cols="9">
        <v-text-field
          v-model="$v.authorityDocument.name.$model"
          :errorMessages="getValidationErrorText($v.authorityDocument.name)"
          label="Наименование документа"
          outlined
        />
      </v-col>
      <v-col cols="3">
        <DateFieldCustom
          label="Дата выдачи"
          :value="$v.authorityDocument.docDate.$model"
          @change="$v.authorityDocument.docDate.$model = $event"
          :errorMessage="$v.authorityDocument.docDate"
          :max="new Date().toISOString()"
        />
      </v-col>

      <v-col cols="6">
        <v-text-field
          v-model="$v.authorityDocument.issuer.$model"
          :errorMessages="getValidationErrorText($v.authorityDocument.issuer)"
          label="Кем выдан"
          outlined
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="$v.authorityDocument.attestation.$model"
          :errorMessages="
            getValidationErrorText($v.authorityDocument.attestation)
          "
          label="Сведения об удостоверении документа"
          outlined
        />
      </v-col>

      <v-col cols="12">
        <AttachDocumentSingle
          :value="{
            file: $v.authorityDocument.file.$model,
            fileSig: $v.authorityDocument.fileSig.$model,
          }"
          :error-messages="getValidationErrorText($v.authorityDocument.file)"
          @change="
            $v.authorityDocument.file.$model = $event.file;
            $v.authorityDocument.fileSig.$model = $event.fileSig;
          "
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mdiAlertCircleOutline } from '@mdi/js';

import AttachDocumentSingle from '@/components/base/AttachDocument/AttachDocumentSingle';
import DateFieldCustom from './DateFieldCustom';
import { and, maxLength, required } from 'vuelidate/lib/validators';
import {
  DATE_FORMAT,
  DATE_FUTURE,
  DATE_PAST,
  EMOJI,
  getValidationErrorText,
} from '@/utils/validate';
import { isNotEmptyObjectCheck } from '@/utils/common';

export default {
  name: 'ConfirmationAuthorityForm',
  components: { DateFieldCustom, AttachDocumentSingle },
  validations() {
    return {
      authorityDocument: {
        name: {
          required,
          maxLength: maxLength(1000),
          EMOJI,
        },
        docDate: {
          required,
          DATE: and(DATE_FORMAT, DATE_FUTURE, DATE_PAST),
        },
        issuer: {
          required,
          maxLength: maxLength(1000),
          EMOJI,
        },
        attestation: {
          maxLength: maxLength(4000),
          EMOJI,
        },
        file: {
          required,
        },
        fileSig: {
          required,
        },
      },
    };
  },
  data: () => ({
    mdiAlertCircleOutline,
    getValidationErrorText,
    authorityDocument: {
      type: 'CONFIRMATION_OF_AUTHORITY',
      name: '',
      docDate: '',
      issuer: '',
      attestation: '',
      file: null,
      fileSig: null,
    },
  }),
  props: {
    document: {
      type: Object,
    },
  },
  created() {
    this.reset();
    if (isNotEmptyObjectCheck(this.document)) {
      this.authorityDocument = this.document;
    }
  },
  methods: {
    touch() {
      this.$v.$touch();
      return this.$v.$invalid;
    },

    async upload() {
      return !this.touch() ? this.authorityDocument : null;
    },
    reset() {
      this.authorityDocument.name = '';
      this.authorityDocument.docDate = '';
      this.authorityDocument.issuer = '';
      this.authorityDocument.attestation = '';
      this.authorityDocument.file = null;
      this.authorityDocument.fileSig = null;
      this.$v.$reset();
    },
  },
};
</script>

<style scoped></style>
